import React from "react";
import styled from "styled-components/macro";

const StyledSpinner = styled.div<SpinnerProps>`
  --size: ${(props) =>
    props.size === "small"
      ? "15px"
      : props.size === "xlarge"
      ? "50px"
      : "30px"};
  --thickness: 2px;
  --color: var(--green);
  --speed: 1s;

  display: inline-block;
  width: var(--size);
  height: var(--size);

  &:after {
    content: " ";
    display: block;
    width: calc(var(--size) - var(--thickness) * 2);
    height: calc(var(--size) - var(--thickness) * 2);
    border-radius: 50%;
    border: var(--thickness) solid var(--color);
    border-color: var(--color) transparent var(--color) transparent;
    animation: spinner var(--speed) linear infinite;
  }
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

interface SpinnerProps {
  className?: string;
  size?: "xlarge" | "large" | "small";
  style?: React.CSSProperties;
}

export const Spinner: React.FC<SpinnerProps> = ({ className, size, style }) => {
  return <StyledSpinner className={className} size={size} style={style} />;
};
